export default __webpack_public_path__ + "book_details-publisher.76771100.png";